import React, { useEffect } from 'react';
import { logoutUser } from 'src/routes/AuthContext';
import loader from 'src/components/LoaderImg/loader.gif';

function LogoutLanding() {
  useEffect(() => {
    logoutUser();
  }, []);

  return (
    <>
      <img
        src={loader}
        alt="loading..."
        style={{ margin: 'auto', display: 'block' }}
      />
    </>
  );
}

export default LogoutLanding;
